module.exports =  {

  whatIsOrdersForMe: {
    title: '什么是"发给我的挂单"?',
    contents: `
      <p>在创建新挂单时，交易者可以填写一个吃单者账号（也可不填），如果一个挂单有指定的吃单者账号，那么只有这个账号的持有者才能与之交易（吃单）。</p>
      <p>当带有指定吃单者账号的挂单产生后，被指定的吃单者会在他/她的“发给我的挂单”页面看到这个挂单并决定是否吃单。
      </p>
    `,
  },

}

